import UserLockPage from "./userlock-page";

export default UserLockPage;
